import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';
import { ShippingApi } from '../models';

const eventsService = createApi({
  reducerPath: 'eventsService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}/event`),
  tagTypes: ['Events'],
  endpoints: (builder) => ({
    updateShippingStatus: builder.mutation<
      ShippingApi,
      { number: string; status: { externalId: string; name: string }; user: string }
    >({
      query: ({ number, status, user }) => ({
        url: '/event-update-status',
        method: 'POST',
        body: {
          eventName: 'event_update_status',
          eventData: {
            number,
            status,
            date: new Date().toISOString()
          },
          user
        },
      }),
      invalidatesTags: ['Events'],
    }),
  }),
});

export default eventsService;

export const {
  useUpdateShippingStatusMutation,
} = eventsService;
